$bog_invest_app $mol_page
	title \ВДО Ребаланс
	pages *
		calc <= Calc $bog_invest_calc
		lk <= Lk $bog_invest_lk
	nav_options *
		calc \Ребаланс
		lk \Кабинет
	Navbar $mol_switch
		value? <=> screen? \calc
		options <= nav_options
	tools /
		<= Sources $mol_link_source
			uri \https://github.com/b-on-g/invest
		<= Status $giper_baza_status
		<= Theme_toggle $bog_theme_toggle
			theme_auto <= Theme
	head /
		<= Title
		<= Navbar
		<= Tools
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_calm_light
			theme_dark \$mol_theme_calm_dark
			themes /
				\$mol_theme_calm_light
				\$mol_theme_calm_dark
	body <= screen_body /
